import React from "react";


const Footer = (links,label) => {

    return(
        <>
    <section className="footerwave">
    {/* Wave effect2  */}
    <div className="wave-effect wave-anim">
      <div className="waves-shape shape-one">
        <div className="wave wave-one wave-one-footer" />
      </div>
      <div className="waves-shape shape-two">
        <div className="wave wave-two wave-two-footer" />
      </div>
      <div className="waves-shape shape-three">
        <div className="wave wave-three wave-three-footer" />
      </div>
    </div>
    {/* Wave effect2 end */}
  </section>
  <footer>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <p><b>© <span> Boomerang Claims</span> Pty Limited</b></p>
          <p>ABN 71 623 924 087
          </p>
          <p>contact@boomerangclaims.com</p>
          <p>Boomerang Claims Limited, Level 2 41A Bay Road, Taren Point, New South Wales, NSW 2229</p>
          <p>Boomerang Claims are proud members of the Australian Financial Complaints Authority. 
            Our membership number is 89098
          </p>
          <p>When deciding how to proceed with your Junk Insurance claim, remember you always have the right to contact AFCA for free and impartial advice and support with your claim. 
            Call AFCA free on 1800 931 678
          </p>
          <ul>
            {/* <li><a href="https://boomerang.claims/privacy" target="_blank"> Privacy Policy</a></li>
            <li><a href="https://boomerang.claims/terms" target="_blank"> Terms of Use</a></li> */}
            
            <li><a href="/privacyV2" target="_blank">Privacy Policy</a></li>
            <li><a href="/TermsV2" target="_blank">Terms of Use</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>






      </>
    );
};

export default Footer;